<template>
	<div id="AttendOrdersComponent">
		<vue-snotify></vue-snotify>
		<nav class="navbar navbar-light">
			<div class="form-inline">
				<label for="inputCodeSearch" ref="labelCodeSearch" v-show="false"></label>
				<input class="form-control form-control-sm mr-sm-1" type="search" id ="inputCodeSearch" placeholder="Escanee código aquí" ref="codesearchref"
                    v-model="codeSearch" v-on:keyup.enter="analyzeSearch()" autofocus @focus="$event.target.select()" :disabled="btnSearchSisabled">
                <span v-if="showOrders">X {{ quantity }}</span>
                <div class="float-right d-none d-sm-inline separator"></div>
			</div>
			<div class="form-inline">
				<i class="fas fa-broom pointer margin-right5" title="Cerrar" @click="clearAttend" v-show="showOrders" ref="btnClearAttend"></i>
                <i class="fas fa-cog pointer" data-toggle="modal" data-target="#modalSettingModule" ref="openModalSettingModule"></i>
			</div>
		</nav>
		<div>
			<div v-if="showOrders" class="row">
				<div class="col-8">
					<table class="table table-sm table-hover">
						<thead>
							<tr class="text-center">
								<th class="text-center">#</th>
								<th class="text-center">Código</th>
								<th class="text-center">Actículo</th>
								<th class="text-center">Cantidad</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in listOrderProducts" :key="index" :class="(item.quantity_attend == item.quantity) ? 'font-weight-bold' : ''">
								<td class="text-center">{{ index + 1 }}</td>
								<td class="text-center" @dblclick="setCodeSearch('H' + item.product_id)" :title="item.isbn">{{ item.product_id }}</td>
								<td>{{ item.product }}</td>
								<td class="text-center">{{ methodFormatNumber(item.quantity_attend) }} / {{ methodFormatNumber(item.quantity) }}</td>
								<td class="text-right">
									<i class="fas fa-check text-success" v-if="item.quantity_attend == item.quantity"></i>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-4" v-if="sendTo != null">
					<div v-show="orderServed">
						<div class="alert alert-info" role="alert">
							Este pedido ya está ATENDIDO!!
						</div>
					</div>
					<div class="card card-info card-outline">
						<div class="card-body box-profile">
							<h3 class="profile-username text-center">{{sendTo.sendto}}</h3>
							<p class="text-muted text-center"></p>
							<ul class="list-group list-group-unbordered mb-3">
								<li class="list-group-item">
									<p><b>Dirección:</b> <span>{{sendTo.address}}</span></p>
									<p><b>Comuna:</b> <span>{{sendTo.comuna}}</span></p>
									<p><b>Telefono:</b> <span>{{sendTo.phone}}</span></p>
								</li>
								<br>
							</ul>
							<button class="btn btn-primary btn-lg btn-block" :disabled="(totalRead < totalQuantity) || savingOrder" @click="saveOrderLocal" v-show="!orderServed">
								<span v-if="savingOrder">
									<div class="spinner-border" role="status">
										<span class="sr-only">Saving...</span>
									</div>
									Guardando . . .
								</span>
								<span v-else>Guardar</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-show="!showOrders && loadingOrder" class="text-center">
			<div class="spinner-border" role="status">
				<span class="sr-only">Loading...</span>
			</div>
			Buscando Orden . . . 
		</div>
        <div class="modal" tabindex="-1" role="dialog" id="modalSettingModule">
            <div class="modal-dialog" role="document">
                <div class="modal-content model-sm">
                    <div class="modal-header">
                        <h5 class="modal-title">Configuraciones del Modulo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col" style="margin-top:15px">
                                Producto no encontrado
                            </div>
                            <div class="col">
                                <audio ref="errorProductN" controls>
                                    <source src="@/assets/sound/error1.mp3" type="audio/mp3">
                                </audio>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="margin-top:15px">
                                Cantidad excedida
                            </div>
                            <div class="col">
                                <audio ref="errorProductQ" controls>
                                    <source src="@/assets/sound/error2.mp3" type="audio/mp3">
                                </audio>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="margin-top:15px">
                                Comprobante no Encontrado
                            </div>
                            <div class="col">
                                <audio ref="withOutVoucher" controls>
                                    <source src="@/assets/sound/error3.mp3" type="audio/mp3">
                                </audio>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="margin-top:15px">
                                Producto encontrado
                            </div>
                            <div class="col">
                                <audio ref="ok1" controls>
                                    <source src="@/assets/sound/ok1.mp3" type="audio/mp3">
                                </audio>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import shippingRequest from '@/mixins/shippingsRequest'
import orders from '@/mixins/orders'

export default {
	name: 'AttendOrdersComponent',
	mixins: [axiosAction, errors, mixin, shippingRequest, orders],
	data () {
		return {
			codeSearch: '',
			idOrdenCurrent: 0,
			quantity: 1,
			listOrdersEnabledAttend: [
				{ id:1 , type_order_id: 9, status_id: 56, save_type_order_id: 11 }
			],
			sendTo: null,
			showOrders: false,
			orderServed: true,
			loadingOrder: false,
			autoSaveComplete: true,
			savingOrder:false
		}
	},
	computed: {
		btnSearchSisabled() {
			if(this.showOrders && this.orderServed)
				return true
			return false
		},
		listOrderProducts() {
			//SE00000000000368660001
			this.objectOrder.order_products.forEach(p => {
				p.ready = parseInt(p.quantity_attend) >= parseInt(p.quantity)
			})
			this.objectOrder.order_products.sort((a, b) => {
				if (a.ready > b.ready) {
					return 1;
				}
				if (a.ready < b.ready) {
					return -1;
				}
				if (a.product > b.product) {
					return 1;
				}
				if (a.product < b.product) {
					return -1;
				}

				return 0;
			});
			return this.objectOrder.order_products
		},
		totalRead() {
			let total = this.objectOrder.order_products.reduce(function(a, b) { let c = parseInt(b.quantity_attend); return a + c}, 0);
            return parseInt(total.toFixed(0))
		},
		totalQuantity() {
			let total = this.objectOrder.order_products.reduce(function(a, b) { let c = parseInt(b.quantity); return a + c}, 0);
			return parseInt(total.toFixed(0))
        },
	},
	methods: {
		analyzeSearch() {
			this.muteEverything()
			this.codeSearch = this.codeSearch.trim()
			if(isNaN(this.codeSearch)) {
				if(this.codeSearch.length == 22) {
					if(this.codeSearch.substring(0,2) == 'SE' && !isNaN(this.codeSearch.substring(2,18))) {
						console.clear()
						if(!this.showOrders) {
							this.getShippingRequestLocal(parseInt(this.codeSearch.substring(2,18)))
						} else {
							this.$refs.withOutVoucher.play()
							alert('Ya se está atendiendo un pedido')
						}
					}
				} else if(this.codeSearch.toUpperCase().substring(0,1) == 'H' && !isNaN(this.codeSearch.substring(1, this.codeSearch.length))) {
					this.searchProduct(parseInt(this.codeSearch.substring(1, this.codeSearch.length)))
				} else if(this.codeSearch.toUpperCase()  == 'ATTENDEVERYTHING' && this.showOrders) {
					this.attendEverything()
				} else if(this.codeSearch.toUpperCase() == 'HELP') {
					console.log('ATTENDEVERYTHING => atiende el pedido completo')
					this.codeSearch = ''
				} else {
					this.$snotify.warning('No sabemos que hacer con esto "' + this.codeSearch + '"', 'Ups!!!')
				}
			} else if(this.codeSearch > 0 && this.showOrders) {
				if(this.codeSearch.length == 13 && !isNaN(this.codeSearch)) {
					this.searchProduct(this.codeSearch)
				} else {
					this.quantity = this.codeSearch
					this.codeSearch = ''
				}
			} else {
				if(this.codeSearch != '') {
					this.$snotify.warning('No sabemos que hacer con esto "' + this.codeSearch + '"', 'Ups!!!')
				}
			}
		},
		attendEverything() {
			this.objectOrder.order_products.forEach(item => {
				item.quantity_attend = item.quantity
			})
			if(this.autoSaveComplete) {
				this.questionSave()
			}
		},
		clearAttend() {
			this.orderServed = true
			this.codeSearch = ''
			this.idOrdenCurrent = 0
			this.quantity = 1
			this.sendTo = null
			this.showOrders = false
			this.loadingOrder = false
			this.savingOrder = false
			this.setDefatultObjectOrder()
			setTimeout(() => {this.$refs.labelCodeSearch.click()}, 100)	
		},
		getShippingRequestLocal(id) {
			this.loadingOrder = true
			this.getShippingRequest(id)
		},
		getShippingRequestResultLocal(response) {
			if(response.data.success == true) {
				if(response.data.data.orders.length == 1 && response.data.data.shipping_request_recipient_data.length == 1) {
					this.sendTo = response.data.data.shipping_request_recipient_data[0]
					this.showOrderLocal(response.data.data.orders[0].id)
				} else {
				}
			} else {
				this.loadingOrder = false
				this.$refs.withOutVoucher.play()
				setTimeout(() => { alert('No se ha encontrado la Solicitud de Envío Nº ' + parseInt(this.codeSearch.substring(2,18))) }, 100)
			}
		},
        muteEverything() {
            this.stopSound(this.$refs.ok1)
            this.stopSound(this.$refs.errorProductN)
            this.stopSound(this.$refs.errorProductQ)
            this.stopSound(this.$refs.withOutVoucher)
        },
		questionSave() {
			if(this.totalRead == this.totalQuantity) {
				if(confirm('Se completó el pedido\n¿Quiere guardarlo?')) {
					this.saveOrderLocal()
				}
			}
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'getShippingRequestResult': this.getShippingRequestResult(response); break;
				case 'saveOrderResult': this.saveOrderResult(response); break;
				case 'showOrderResult': this.showOrderResult(response); break;
				case 'resultAddShippingRequestTrackingsShippingRequestPOST': this.resultAddShippingRequestTrackingsShippingRequestPOST(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
	    resultAddShippingRequestTrackingsShippingRequestPOST(response){
            this.$snotify.success('Solicitud de envío ' + response.data.data.shipping_request_id + ' atendida!!!', 'OK!');
        },
		saveOrderLocal() {
			if(this.totalRead == this.totalQuantity) {
				let index = this.listOrdersEnabledAttend.map((el) => parseInt(el.type_order_id)).indexOf(parseInt(this.objectOrder .type_order_id))
				if(index > -1) {
					this.savingOrder = true
					this.idOrdenCurrent = this.objectOrder.id
					this.objectOrder.exists = 0
					this.objectOrder.id = 0
					this.objectOrder.type_order_id = this.listOrdersEnabledAttend[index].save_type_order_id
					this.objectOrder.status_id = null
					this.objectOrder.total = 0
					this.objectOrder.tithe = 0
					this.objectOrder.paid = 0
					this.saveOrderAttend(this.idOrdenCurrent, this.objectOrder)
				}
			}
		},
		saveOrderResultLocal(response) {
			if(response.data.success == true) {
				this.addShippingRequestTrackingsShippingRequest(this.sendTo.shipping_request_id, 10)
				this.clearAttend()
			} else {
				this.savingOrder = false
				this.$snotify.warning('Por algún motivo extraño no se guardó la atención', 'Ups!!!');
				console.log(response)
			}
		},
		searchProduct(code) {
			// SE00000000000368660001
			// SE00000000000262950001
			let indexs = []
			this.objectOrder.order_products.forEach((p, i) => {
				if(parseInt(p.product_id) == parseInt(code) || parseInt(p.isbn) == parseInt(code)) {
					indexs.push(i)
				}
			});
			if(indexs.length > 0) {
				this.toDiscountProduct(indexs)
			} else {
				console.log('No se encontró el Articulo "' + code + '"')
				this.$refs.errorProductN.play()
			}
			this.codeSearch = ''
		},
		setCodeSearch(value = '') {
			this.codeSearch = value
			setTimeout(() => {this.$refs.labelCodeSearch.click()}, 100)
		},
		setDefatultObjectOrder() {
			this.clearObjectOrder()
		},
		showOrderLocal(id) {
			this.showOrderForAttend(id)
		},
		showOrderResultLocal(response) {
			if(response.data.success == true) {
				let index = this.listOrdersEnabledAttend.map((el) => parseInt(el.type_order_id)).indexOf(parseInt(response.data.data.type_order_id))
				if(index > -1) {
					this.clearObjectOrder()
					this.setObjectOrder(response.data.data)
					this.showOrders = true
					this.codeSearch = ''
					this.orderServed = true
					if(this.listOrdersEnabledAttend[index].status_id == response.data.data.status_id) {
						this.orderServed = false
						this.setCodeSearch()
					} else {
						this.$refs.withOutVoucher.play()
						this.$snotify.warning('La Orden Nº ' + response.data.data.id + ' tiene el estado "' + response.data.data.status.name + '"', 'No Atiende')
						//this.clearAttend()
					}
				} else {
					this.$refs.withOutVoucher.play()
					this.$snotify.warning('El tipo de Orden "' + response.data.data.type_order.name + '" no se atiende', 'No Atiende')
					this.clearAttend()
				}
			}
			this.loadingOrder = false
		},
		toDiscountProduct(indexs) {
			let quantityAttend = 0
			let quantity = 0
			indexs.forEach(i => {
				quantityAttend+= parseInt(this.objectOrder.order_products[i].quantity_attend)
				quantity+= parseInt(this.objectOrder.order_products[i].quantity)
			});
			if((parseInt(quantityAttend) + parseInt(this.quantity)) > parseInt(quantity)) {
				this.$refs.errorProductQ.play()
				console.log('Cantidad excede lo pedido ', this.objectOrder.order_products[indexs[0]])
				alert('La cantidad ingresada (' + this.quantity + ') excede de lo que falta a "' + this.objectOrder.order_products[indexs[0]].product + ' (cod: ' + this.objectOrder.order_products[indexs[0]].product_id + ')"\nLinea ' + (parseInt(indexs[0]) + 1))
			} else {
				indexs.forEach(i => {
					this.objectOrder.order_products[i].quantity_attend = parseInt(this.quantity) + parseInt(this.objectOrder.order_products[i].quantity_attend)
					this.quantity = 0
					if(parseInt(this.objectOrder.order_products[i].quantity_attend) > parseInt(this.objectOrder.order_products[i].quantity)) {
						this.quantity = parseInt(this.objectOrder.order_products[i].quantity_attend) - parseInt(this.objectOrder.order_products[i].quantity)
						this.objectOrder.order_products[i].quantity_attend = this.objectOrder.order_products[i].quantity
					}
				})
				this.$refs.ok1.play()
				this.quantity = 1
			}

			if(this.autoSaveComplete) 
				this.questionSave()
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
